// --- Core ---
import {FC} from "react";
import {FieldRenderProps} from "react-final-form";
// --- SaniQ ---
import {SaniQTextFieldProps, TextField} from "helpers/forms/fields/TextField";

interface NumberFieldProps extends FieldRenderProps<number> {
  // The minimum value for the number input field
  min: number;
  // The maximum value for the number input field
  max: number;
  // The step value for the number input field
  step: number;
}

/**
 * NumberField final-form input component
 */
export const NumberField: FC<NumberFieldProps & SaniQTextFieldProps> = ({step, min, max, ...props}) => (
  <TextField
    type="number"
    inputProps={
      {
        step: step,
        min: min,
        max: max
      }
    }
    {...props}
  />
);
